import * as z from 'zod';

import { currencyInput } from '@/_schemas/generic';

import {
  agreementInstallmentsQuerySchema,
  agreementPaymentQuerySchema,
  paymentStatus,
  paymentType,
} from './agreement-installments-query-schema';

export const agreementPaymentFormSchema = agreementPaymentQuerySchema
  .omit({
    amount: true,
    payment_date: true,
    payment_type: true,
    payment_status: true,
  })
  .extend({
    amount: currencyInput.formSchemaWithValidation(0),
    payment_date: z.string().refine((val) => !!val, {
      error: 'Payment date is required',
    }),
    payment_type: z.object({ name: z.string(), value: paymentType }),
    payment_status: z.object({ name: z.string(), value: paymentStatus }),
  });

export type AgreementPaymentFormSchema = z.infer<typeof agreementPaymentFormSchema>;

export const agreementInstallmentFormSchema = agreementInstallmentsQuerySchema
  .omit({
    wholesale_amount: true,
    contracted_amount: true,
    due_date: true,
    invoice_number: true,
    paid: true,
    remaining_balance: true,
    agreement_id: true,
    agreement_payments: true,
    invoice_id: true,
  })
  .extend({
    wholesale_amount: currencyInput.formSchemaWithValidation(),
    contracted_amount: currencyInput.formSchemaWithValidation(),
    due_date: z.string().refine((val) => !!val, {
      error: 'Due date is required',
    }),
    invoice_number: z.string().min(1).max(30, {
      error: 'Invoice number must be less than 30 characters',
    }),
    paid: z.boolean().optional(),
    remaining_balance: z.number(),
    agreement_payments: z.array(agreementPaymentFormSchema),
  });

export type AgreementInstallmentFormSchema = z.infer<typeof agreementInstallmentFormSchema>;
